import { MapPin, Star } from "lucide-react";
import { REVIEWS } from "@/lib/content";
import { Eyebrow, Reveal } from "./Reveal";

export const Reviews = () => (
  <section id="reviews" data-testid="reviews-section" className="bg-[#F5F0E6] py-24 text-[#0B0F17] lg:py-36">
    <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
      <div className="flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
        <div>
          <Reveal><Eyebrow light>Reviews</Eyebrow></Reveal>
          <Reveal delay={0.1}><h2 className="mt-5 font-display text-4xl leading-[1.05] sm:text-5xl lg:text-6xl">Trusted on both sides <span className="italic text-[#8a6d2f]">of State Line.</span></h2></Reveal>
        </div>
      </div>
      <div className="mt-14 grid gap-4 md:grid-cols-3">
        {REVIEWS.map((r, i) => (
          <Reveal key={i} delay={i * 0.1} className="h-full">
            <figure data-testid={`review-card-${i}`} className="flex h-full flex-col justify-between border border-[#0B0F17]/10 bg-white p-8 transition-[transform,box-shadow] duration-500 hover:-translate-y-1 hover:shadow-[0_30px_60px_-30px_rgba(11,15,23,0.35)]">
              <div>
                <div className="flex gap-1 text-[#B08A3E]" aria-label="5 out of 5 stars">
                  {Array.from({ length: 5 }).map((_, k) => <Star key={k} className="h-4 w-4 fill-current" />)}
                </div>
                <blockquote className="mt-6 font-display text-xl leading-snug text-[#1a1f29] sm:text-[1.35rem]">“{r.quote}”</blockquote>
              </div>
              <figcaption className="mt-8 border-t border-[#0B0F17]/10 pt-5">
                <span className="block font-semibold">{r.name}</span>
                <span className="mt-1 flex items-center gap-1.5 text-sm text-[#4B5059]"><MapPin className="h-3.5 w-3.5" /> {r.place} · {r.project}</span>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
